import { gql } from "@apollo/client";
import { useQuery, useApolloClient } from "@apollo/client/react";

const query = gql`
  query($uri: String) {
    entry(uri: [$uri]) {
      ...on page_Entry {
          # Same reason as in usePage: both queries write to Query.entry, and
          # Apollo 3 can only merge them if the object is normalisable.
          id
          showCookieModal
          showFooter
          ismainnavbackgrounded
          isSmoothScrollDisabled
      }
        ... on clubdataprivacycenterpage_Entry {
            id
            typeHandle
        }
    }
    seomatic (uri: $uri) {
      metaTitleContainer
      metaTagContainer
    }
  }
`;

const usePageOptions = (uri) => {
  const client = useApolloClient();

  let params = {
      client: client,
      notifyOnNetworkStatusChange: true
  };

  params.variables = { uri };

  return useQuery(query, params);
};

export default usePageOptions;
